import React from "react";
import { config } from "../config/environment";

/**
 * A persistent yellow banner shown ONLY on the staging deployment so testers
 * always know they're not on production.
 *
 * Gated strictly on `config.environment === 'dev'` — which resolves to the
 * staging stack (dev.bespokecast.ai / api-dev.bespokecast.ai) via the build-time
 * REACT_APP_ENVIRONMENT or the dev.bespokecast.ai hostname fallback (see
 * config/environment.ts). It NEVER renders on prod, local, or fake.
 *
 * Fixed to the bottom edge so it doesn't overlap the top nav, full-width and
 * always visible. `pointer-events-none` so it never intercepts clicks on the
 * content beneath it.
 */
export default function StagingBanner(): React.ReactElement | null {
  if (config.environment !== "dev") return null;

  return (
    <div
      role="status"
      aria-label="Staging environment"
      data-testid="staging-banner"
      className="fixed bottom-0 inset-x-0 z-[9999] bg-yellow-400 text-yellow-950 text-center text-sm font-semibold py-1 px-2 shadow-[0_-1px_4px_rgba(0,0,0,0.15)] pointer-events-none select-none"
    >
      ⚠️ STAGING ENVIRONMENT — test data, not production
    </div>
  );
}
